module.exports = __webpack_public_path__ + "img/image-right-qlty.35a7698d.jpg";